import React from 'react';

// Generic Text Section
const TextSection = ({ data }) => {
  const { heading, content, text_align = 'left', background_color } = data || {};
  
  const bgStyle = background_color ? { backgroundColor: background_color } : {};
  const alignClass = text_align === 'center' ? 'text-center' : text_align === 'right' ? 'text-right' : 'text-left';
  
  return (
    <section className="py-16 px-4" style={bgStyle}>
      <div className={`max-w-4xl mx-auto ${alignClass}`}>
        {heading && (
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {heading}
          </h2>
        )}
        {content && (
          <div 
            className="rich-content prose prose-lg max-w-none text-gray-700"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </section>
  );
};

export default TextSection;
